import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import DateSelection from "./DateSelection";
import { Tooltip } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import { motion, AnimatePresence } from "framer-motion";

//---------------------------------------------------------------

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background-color: whitesmoke;
  flex: 1;
  z-index: 9999;
`;

const HeaderBarButtonContainer = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-arrows-rotate {
    font-size: 17px;
    //spin it half a turn on hover
    transform: rotate(0deg);
    transition: transform 0.13s ease-in-out;
    cursor: pointer;
    &:hover {
      transform: rotate(150deg);
    }
  }
  .header-button {
    color: #464646;
    font-size: 17px;
    cursor: pointer;
    &:hover {
      color: ${({ theme }) => theme.colors.blue};
    }
  }
`;

const closeIconAndDateVariants = {
  visible_icon: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
    },
  },
  hidden_icon: {
    opacity: 0,
    y: 20,
    transition: {
      duration: 0.0,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },

  hidden: {
    opacity: 0,
    transition: {
      duration: 0.0,
    },
  },
};

const RoutingContainer = styled.div`
  margin-left: 10px;
  @media (max-width: 700px) {
    display: none;
  }
`;

const NonHideableButtonContainer = styled.div`
  cursor: pointer;
  &:hover {
    filter: brightness(0.6);
  }
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  //background-color: white;
`;

const HideableButtonContainer = styled.div`
  //less than 1200px display none
  @media (max-width: 900px) {
    display: none;
  }
  cursor: pointer;
  &:hover {
    filter: brightness(0.6);
  }
  position: relative;
`;

const UnderLineIndicator = styled.div`
  position: absolute;
  bottom: 2px;
  background-color: #1e90ff;
  height: 3px;
  width: 20px;
`;

//---------------------------------------------------------------

// isStaffPlanner: boolean;
// setIsStaffPlanner: (isStaffPlanner: boolean) => void;
// isVehiclePlanner: boolean;
// setIsVehiclePlanner: (isVehiclePlanner: boolean) => void;

const SchedulePlannerBarContent = ({
  date,
  setDate,
  handleDateChange,
  refetch,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const isStaffRoute = currentPath.includes("/schedule_planner/staff");
  const isVehicleRoute = currentPath.includes("/schedule_planner/vehicles");

  const navigate = useNavigate();
  return (
    <Container>
      <AnimatePresence>
        <HeaderBarButtonContainer
          variants={closeIconAndDateVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={() => navigate("/home")}
        >
          <i className="fa-solid fa-home header-button"></i>
          <RoutingContainer>
            <i
              style={{
                fontSize: "8px",
              }}
              className="fa-solid fa-angle-right"
            ></i>
            <span
              style={{
                fontSize: "10px",
                marginLeft: "5px",
              }}
            >
              Schedule Planner
            </span>
            {isStaffRoute && (
              <>
                <i
                  style={{
                    fontSize: "8px",
                    marginLeft: "5px",
                  }}
                  className="fa-solid fa-angle-right"
                ></i>
                <span
                  style={{
                    fontSize: "10px",
                    marginLeft: "5px",
                  }}
                >
                  Staff
                </span>
              </>
            )}

            {isVehicleRoute && (
              <>
                <i
                  style={{
                    fontSize: "8px",
                    marginLeft: "5px",
                  }}
                  className="fa-solid fa-angle-right"
                ></i>
                <span
                  style={{
                    fontSize: "10px",
                    marginLeft: "5px",
                  }}
                >
                  Vehicles
                </span>
              </>
            )}
          </RoutingContainer>
        </HeaderBarButtonContainer>
      </AnimatePresence>
      <AnimatePresence>
        <motion.div
          variants={closeIconAndDateVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <DateSelection
            date={date}
            setDate={setDate}
            handleDateChange={handleDateChange}
          />
        </motion.div>
      </AnimatePresence>
      <AnimatePresence>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NonHideableButtonContainer
            onClick={() => {
              navigate("/schedule_planner/staff");
            }}
          >
            <Tooltip title={"View staff planner"}>
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <GroupIcon color="primary" sx={{ fontSize: 28 }} />
              </div>
            </Tooltip>
            {isStaffRoute && <UnderLineIndicator />}
          </NonHideableButtonContainer>
          <NonHideableButtonContainer
            onClick={() => {
              navigate("/schedule_planner/vehicles");
            }}
          >
            <Tooltip title={"View vehicle planner"}>
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <DirectionsBusIcon color="primary" sx={{ fontSize: 23 }} />
              </div>
            </Tooltip>
            {isVehicleRoute && <UnderLineIndicator />}
          </NonHideableButtonContainer>
          <HeaderBarButtonContainer
            variants={closeIconAndDateVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            onClick={() => {
              //refetch with react-query
              refetch();
            }}
          >
            <i className="fa-solid fa-arrows-rotate header-button"></i>
          </HeaderBarButtonContainer>
        </div>
      </AnimatePresence>
    </Container>
  );
};

export default SchedulePlannerBarContent;
